import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import Arrow from 'app/Components/Shared/Arrow';
import CircularBadge from 'app/Components/Shared/CircularBadge';
import {getTextWithHighlight, splitMarketingText} from 'app/utilities/highlightText';
import AbroadCellularPackageBlockData from 'Models/Content/AbroadCellularPackageBlockData';
import IconBlockData from 'Models/Content/IconBlockData';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';
import React, {useContext} from 'react';
import {getImageProps} from 'app/utilities/ImageProps';
import {PopupContext} from 'app/utilities/PopupContext';
import {isMobile} from 'react-device-detect';

const AbroadCellularPackageBlock = ({data, context}: ComponentProps<AbroadCellularPackageBlockData>) => {
  const titleAndSubtitleMarketingText = data.marketingTextsContentArea.expandedValue[0] as MarketingTextBlockData;
  const [title, subtitle] = splitMarketingText({
    text: titleAndSubtitleMarketingText.text.value,
    highlightText: titleAndSubtitleMarketingText.highlightText.value,
  });

  const {setPopUpData} = useContext(PopupContext);

  const durationMarketingText = data.duration.expandedValue[0] as MarketingTextBlockData;
  const renderDuration = getTextWithHighlight({
    text: durationMarketingText.text.value,
    highlightText: durationMarketingText.highlightText.value,
  });

  const openPopup = (event, summary: string, title: string) => {
    event.preventDefault();
    setPopUpData({
      summary,
      title,
    });
  };

  return (
    <div className='AbroadCellularPackageBlock'>
      {/* <a href={data.buttonLink.value}>
        {data.circularIconText.value && (
          <CircularBadge className='AbroadCellularPackageBlock__badge'>{data.circularIconText.value}</CircularBadge>
        )}

        <h3>
          <div className='AbroadCellularPackageBlock__title'>{title}</div>
          <br />
          <div className='AbroadCellularPackageBlock__subtitle'>{subtitle}</div>
        </h3>

        {data.icons.expandedValue && data.icons.expandedValue.length > 0 && (
          <div className='AbroadCellularPackageBlock__no-limit-apps'>
            {data.icons.expandedValue.map((icon: IconBlockData) => (
              <img key={icon.contentLink.id} {...getImageProps(icon.image, context)} />
            ))}
            <div className='AbroadCellularPackageBlock__no-limit-apps__text'>{data.iconsDescription.value}</div>
          </div>
        )}

        {data.packageIncludes.expandedValue && data.packageIncludes.expandedValue.length > 0 && (
          <div className='AbroadCellularPackageBlock__features'>
            {data.packageIncludes.expandedValue.map(({text, highlightText, contentLink}: MarketingTextBlockData) => {
              const [label, value] = splitMarketingText({text: text.value, highlightText: highlightText.value});

              return (
                <div key={contentLink.id} className='AbroadCellularPackageBlock__features__feature'>
                  <div className='AbroadCellularPackageBlock__features__feature__label'>{label}</div>
                  <div className='AbroadCellularPackageBlock__features__feature__value'>{value}</div>
                </div>
              );
            })}
          </div>
        )}

        <div className='AbroadCellularPackageBlock__price-and-button'>
          <div className='AbroadCellularPackageBlock__price-and-button__price-and-duration'>
            <div className='AbroadCellularPackageBlock__price-and-button__price-and-duration__price'>
              <span className='AbroadCellularPackageBlock__price-and-button__price-and-duration__price__ils'>₪</span>
              {data.price.value}
            </div>

            <div className='AbroadCellularPackageBlock__price-and-button__price-and-duration__duration'>{renderDuration}</div>
          </div>

          <div className='AbroadCellularPackageBlock__price-and-button__button'>
            {data.buttonLinkTitle.value} <img src={require('./images/icons.svg')} />
          </div>
        </div>
      </a> */}

      <a href={data.buttonLink.value}>
        {data.circularIconText.value && (
          <CircularBadge className='AbroadCellularPackageBlock__badge'>{data.circularIconText.value}</CircularBadge>
        )}

        <h3>
          <div className='AbroadCellularPackageBlock__title'>{title}</div>
          <br />
        </h3>

        <div className='AbroadCellularPackageBlock__subtitle'>{subtitle}</div>

        {data.icons.expandedValue && data.icons.expandedValue.length > 0 && (
          <div className='AbroadCellularPackageBlock__no-limit-apps'>
            {data.icons.expandedValue.map((icon: IconBlockData) => (
              <Image key={icon.contentLink.id} {...getImageProps(icon.image, context)} />
            ))}
            <div className='AbroadCellularPackageBlock__no-limit-apps__text'>{data.iconsDescription.value}</div>
          </div>
        )}

        {data.packageIncludes.expandedValue && data.packageIncludes.expandedValue.length > 0 && (
          <div className='AbroadCellularPackageBlock__features'>
            {data.packageIncludes.expandedValue.map(({text, highlightText, contentLink}: MarketingTextBlockData) => {
              const [label, value] = splitMarketingText({text: text.value, highlightText: highlightText.value});

              return (
                <div key={contentLink.id} className='AbroadCellularPackageBlock__features__feature'>
                  <div className='AbroadCellularPackageBlock__features__feature__label'>{label}</div>
                  <div className='AbroadCellularPackageBlock__features__feature__value'>{value}</div>
                </div>
              );
            })}
          </div>
        )}

        <div className='AbroadCellularPackageBlock__prices-and-button'>
          <div className='AbroadCellularPackageBlock__prices-and-button__price-and-button'>
            <div className='AbroadCellularPackageBlock__prices-and-button__price-and-button__price'>
              <span className='AbroadCellularPackageBlock__prices-and-button__price-and-button__price__ils'>₪</span>
              {data.price.value}
            </div>

            <div className='AbroadCellularPackageBlock__prices-and-button__price-and-button__button'>
              {data.buttonLinkTitle.value} <Image src={require('./images/icons.svg')} />
            </div>
          </div>

          <div className='AbroadCellularPackageBlock__prices-and-button__price-and-duration'>
            {data.fullPrice?.value && (
              <span className='AbroadCellularPackageBlock__prices-and-button__price-and-duration__full-price'>₪{data.fullPrice.value}</span>
            )}

            <span className='AbroadCellularPackageBlock__prices-and-button__price-and-duration__duration'>{renderDuration}</span>
          </div>
        </div>
      </a>

      <div className='AbroadCellularPackageBlock__bottom-links'>
        <a
          onClick={(e) => openPopup(e, data.supportedCountries.value, data.supportedCountriesLinkTitle.value)}
          className='AbroadCellularPackageBlock__bottom-links__link'>
          {data.supportedCountriesLinkTitle.value} <Arrow />
        </a>
        <a
          onClick={(e) => openPopup(e, data.youShouldKnow.value, data.youShouldKnowLinkTitle.value)}
          className='AbroadCellularPackageBlock__bottom-links__link'>
          {data.youShouldKnowLinkTitle.value} <Arrow />
        </a>
      </div>
    </div>
  );
};

export default AbroadCellularPackageBlock;
